export const MCSA_JOURNEY_COPY = {
    eyebrow: 'MindShield · Atlas',
    headline: 'Your journey through the mind',
    body: "Six little worlds, one curious you. We'll explore how your mind moves through everyday cyberspace. There are no wrong answers, just you being you.",
    ready: 'Ready, explorer?',
    start_label: 'Start',
    nudge_before: 'Tap ',
    nudge_after: ' to begin your adventure',
    back_to_map: 'Back to the map',
    back_to_map_short: 'Map',
    theme_label: 'Theme',
    check_ins_label: 'quick check-ins',
    focus_game_label: 'focus game',
    focus_games_label: 'focus games',
    skip_game: 'Skip game',
    back: 'Back',
    previous: 'Previous',
    next: 'Next',
    finish_theme: 'Finish theme',
    bipolar_labels: ['Definitely', 'Somewhat', 'Somewhat', 'Definitely'] as const,
    shop_opts: ['Definitely me', 'Mostly me', 'Not really', 'Not me'] as const,
    chat_opts: ['So me 💯', 'Kinda me', 'Not really', 'Nope, not me'] as const,
    like_opts: ['Highly likely', 'Likely', 'Not very likely', 'Not likely at all'] as const,
    risk_opts: ['Highly risky', 'Risky', 'Slightly risky', 'Not risky'] as const,
    like_caption: 'How likely am I to do this?',
    risk_caption: 'How risky do I think it is?',
    slider_hint: "Slide to wherever feels true. There's no rush.",
    stamp_hint: 'Stamp where you land →',
    swipe_hint: 'Tap what fits — quick! Out of time just saves it for later.',
    thermo_hint: 'Slide the gauge to where you sit.',
    thermo_left: '← Fully me',
    thermo_right: 'Fully me →',
    dual_hint: '👀 You know the risk and do it anyway — worth a look later',
    boarding_pass: 'Boarding Pass',
    airline: 'MindShield Air',
    left_label: 'left',
    complete: 'complete',
    affirm_title: 'Beautifully done! 🎉',
    affirm_lock: '🔒 Full cognitive security report will be available at the end!',
    affirm_continue: 'Continue',
    affirm_almost: 'You are almost there!',
    affirm_finish: 'You are at the finish line!',
    wildcard_eyebrow: '⚡ Wild Card',
    wildcard_cta: 'Onward!',
    finish_title: "You've mapped every world! 🏆",
    finish_body_before: "Six worlds, one wonderfully curious mind... and you explored them all! We're weaving your answers into your ",
    finish_body_highlight: 'full cognitive security report',
    finish_body_after: ', coming up next.',
    finish_stay: 'Stay TUNED!',
    view_results: 'View my results',
};

export const MCSA_WORLD_HERO_PATH = '/assets/mcsa/worlds';
export const MCSA_FINISH_HERO = '/assets/mcsa/worlds/img3.jpg';
export const MCSA_SHOP_SECONDS = 9;
